/**
 * Utility functions for formatting data
 */

/**
 * Format role name for display
 * Converts kebab-case role names to Title Case
 * @param {string} role - Role name (e.g., 'super-admin', 'professor')
 * @returns {string} Formatted role name (e.g., 'Super Admin', 'Professor')
 */
export const formatRoleName = (role) => {
  if (!role) return ''
  
  return role
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

/**
 * Check if a role is an administrative role
 * @param {string} role - Role name
 * @returns {boolean} True if role is admin-level
 */
export const isAdminRole = (role) => {
  const adminRoles = ['super-admin', 'ceo', 'coordinator']
  return adminRoles.includes(role)
}

/**
 * Format date to readable string
 * @param {string|Date} date - Date to format
 * @returns {string} Formatted date string
 */
export const formatDate = (date) => {
  if (!date) return ''
  
  const d = new Date(date)
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}

/**
 * Format date and time to readable string
 * @param {string|Date} date - Date to format
 * @returns {string} Formatted date and time string
 */
export const formatDateTime = (date) => {
  if (!date) return ''
  
  const d = new Date(date)
  return d.toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

/**
 * Format phone number
 * @param {string} phone - Phone number
 * @returns {string} Formatted phone number
 */
export const formatPhoneNumber = (phone) => {
  if (!phone) return ''
  
  // Remove all non-numeric characters
  const cleaned = phone.replace(/\D/g, '')
  
  // Format based on length
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
  }
  
  return phone
}

export default {
  formatRoleName,
  isAdminRole,
  formatDate,
  formatDateTime,
  formatPhoneNumber
}
